<div
  class="skeleton skeleton-field"
  [ngClass]="{ 'skeleton-field--textarea': variant === 'textarea' }"
  aria-hidden="true"
></div>
